import React from 'react';
import controller from './controller';
import stateManager from '../../state';
import Container from './container';

export default () => <Container stateManager={stateManager} controller={controller} />
